import styled, { keyframes } from 'styled-components';

const fadein = keyframes`
    to {
        opacity: 1;
    }
`;

export const StyledCheckout = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-family: ${(props: any) => props.fontFamily};
    margin: 16px;

    .fadein,
    button {
        animation: ${fadein} 1s linear 0.7s forwards;
        opacity: 0;
    }
    button {
        margin-bottom: 16px;
    }
` as any;
